import React from 'react';

interface LoadingOverlayProps {
  message: string;
}

const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ message }) => {
  return (
    <div className="loading-overlay">
      <img
        src="/images/belle-spinner.gif"
        alt="Loading..."
        className="belle-spinner"
      />
      <div className="loading-text">
        {message}
      </div>
    </div>
  );
};

export default LoadingOverlay; 